<template>
  <v-container style="height: 91vh !important;" class="d-flex align-center justify-center" fluid>
    <v-row align="center" justify="center">
      <v-row class="mb-3 mt-n5" style="min-width: 80% !important; max-width: 80% !important;" align="center" justify="center">
        <v-col cols="8"><v-btn @click="backToTest">{{ $t('btnBackToTest') }}</v-btn></v-col>
        <v-spacer/>
        <v-col cols="4" class="mb-n3">
          <v-img :src="$store.state.fundingTest.evaluation.vendorLogoUrl" position="center right" max-height="37" m contain/>
        </v-col>
      </v-row>

      <!-- Funding Test Feedback !-->
      <v-row align="center" justify="center">
        <v-card class="py-5 px-10" style="min-width: 80% !important;" id="confettiable" dark outlined>
          <v-overlay :absolute="true" :value="overlayLoadingDetails"><v-progress-circular color="primary" :size="70" width="5" indeterminate/></v-overlay>
          <v-container fluid>
            <v-row :class="(status === 'WINNER')? 'winner' : (status === 'DISQUALIFIED')? 'disqualified' : 'abandoned'">
              <v-col class="d-flex align-center justify-start">
                <v-icon class="text-icon" large>{{ getStatusIcon() }}</v-icon>
                <h1 class="text-icon ml-2">{{ $t(`titles.${$store.state.fundingTest.status}`) }}</h1>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex align-center justify-start" cols="6">
                <div :class="(status === 'WINNER')? 'winner' : (status === 'DISQUALIFIED')? 'disqualified' : 'abandoned'">
                  <v-card class="border py-5 px-7" outlined>
                    <p class="mb-0">{{ $t('target.targetTitle') }}</p>
                    <h2 class="white-content">${{ new Intl.NumberFormat().format(getProfitTarget().toFixed(2)) }}</h2>
                    <p class="text-icon mt-3 mb-0">{{ $t('target.reachedProfitTitle') }}</p>
                    <h2 class="text-icon">${{ new Intl.NumberFormat().format(Number($store.state.fundingTest.currentProfit.toFixed(2))) }}</h2>
                  </v-card>
                </div>
                <div class="disqualified ml-3">
                  <v-card class="border py-5 px-7" outlined>
                    <p class="mb-0">{{ $t('drawdown.maxTitle') }}</p>
                    <h2 class="white-content">-${{ new Intl.NumberFormat().format(getDrawdownLimit().toFixed(2)) }}</h2>
                    <p class="text-icon mt-3 mb-0">{{ $t('drawdown.currentTitle') }}</p>
                    <h2 class="text-icon">-${{ new Intl.NumberFormat().format(Number(getMaxDrawdown().toFixed(2))) }}</h2>
                  </v-card>
                </div>
              </v-col>
              <v-col cols="6">
                <h2 class="white-content">{{ $t('summary.title') }}</h2>
                <p v-if="market !== undefined">{{ $t(`summary.market.${market}`) }}</p>
                <div class="d-flex align-center justify-start mt-3">
                  <v-icon class="text-icon" small>fa-calendar</v-icon>
                  <p class="white-content ml-2 my-0"
                     v-html="$t('dateRange', { from: formatDate(new Date($store.state.fundingTest.createdAt)), to: formatDate(new Date($store.state.fundingTest.finishedAt)) })"/>
                  <p class="ml-2"></p>
                </div>
                <div class="d-flex align-center justify-start my-1">
                  <v-icon class="text-icon" small>fa-calendar-week</v-icon>
                  <p class="white-content ml-2 my-0"
                     v-html="$tc('totalDays', this.activeDays, { days: this.totalDays })"/>
                </div>
                <div class="d-flex align-center justify-start">
                  <v-icon class="text-icon" small>fa-suitcase</v-icon>
                  <p class="white-content ml-2 my-0"
                     v-html="$t('brokerAccount', { broker: $store.state.fundingTest.account.brokerName, identifier: $store.state.fundingTest.account.identifier })"/>
                </div>
                <div :class="`${(status === 'WINNER')? 'winner' : (status === 'DISQUALIFIED')? 'disqualified' : 'abandoned'} d-flex align-center justify-start mt-5`">
                  <v-btn class="button" @click="restartTest">
                    {{ $t('btnRestart') }} <v-icon class="ml-2" x-small>fa-sync-alt</v-icon>
                  </v-btn>
                  <v-btn v-if="status === 'WINNER'" class="button ml-2" @click="goToVendor">
                    {{ $t('btnGoToVendor', { vendor: $store.state.fundingTest.evaluation.vendorName }) }} <v-icon class="ml-2" x-small>fa-external-link-alt</v-icon>
                  </v-btn>
                </div>

              </v-col>
            </v-row>
            <RulesOverview :collapsed="true"/>
          </v-container>
        </v-card>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../../../../repositories/funding';
import { mapMutations } from 'vuex';
import RulesOverview from "@/views/Funding/Simulation/components/RulesOverview";
import VueConfetti from 'vue-confetti';
import Vue from 'vue';

Vue.use(VueConfetti);

export default {
  name: "TestFeedback",
  components: {RulesOverview},
  props: {
    testId: Number,
    market: String,
  },
  data() {
    return {
      status: '',
      winner: false,
      disqualified: false,
      overlayLoadingDetails: false,
      months: [],
      totalDays: 0,

      // Confetti
      confettiOptions: {
        defaultColors: [
          'PaleGreen',
          'Gold',
          'lightblue',
        ],
        defaultDropRate: 6,
        defaultSize: 5,
        windSpeedMax: 0,
        particlesPerFrame: 1,
      },
    };
  },
  mounted() {
    this.init();
  },
  destroyed() {
    this.$confetti.stop();
  },
  methods: {
    ...mapMutations(['setFundingTest']),
    init() {
      this.overlayLoadingDetails = true;
      this.getMonths();

      if(this.market === undefined && this.testId === undefined && this.$store.state.fundingTest === null)
        this.$router.push({ name: 'funding-simulation-home' });

      let testId = (this.testId !== undefined)? this.testId : this.$store.state.fundingTest.id;

      Repository.fundingTestOverview(testId).then((response) => {
        if(response.status < 400) {
          this.overlayLoadingDetails = false;
          this.setFundingTest(response.data);
          this.status = this.$store.state.fundingTest.status;

          if(this.status === 'WINNER')
            this.$confetti.start(this.confettiOptions);
          this.calculateDays();
        }
      });
    },
    calculateDays() {
      let Difference_In_Time_Total = new Date().getTime() - new Date(this.$store.state.fundingTest.createdAt).getTime();
      this.totalDays = Math.floor(Difference_In_Time_Total / (1000 * 3600 * 24));
    },
    getMonths() {
      this.months = [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec'),
      ];
    },
    getStatusIcon() {
      switch (this.$store.state.fundingTest.status) {
        case 'WINNER':
          return 'fa-glass-cheers';
        case 'DISQUALIFIED':
          return 'fa-times';
        default:
          return 'fa-running';
      }
    },
    getProfitTarget() {
      return Number(this.$store.state.fundingTest.evaluation.target) - Number(this.$store.state.fundingTest.evaluation.initialBalance);
    },
    getDrawdownLimit() {
      let drawdownRule = this.$store.state.fundingTest.ruleStatuses.find((ruleStatus) => ruleStatus.rule === 'MAX_DRAWDOWN');
      return (drawdownRule !== undefined)? Math.abs(drawdownRule.referenceValue) : 0;
    },
    getMaxDrawdown() {
      let drawdownRule = this.$store.state.fundingTest.ruleStatuses.find((ruleStatus) => ruleStatus.rule === 'MAX_DRAWDOWN');
      return (drawdownRule !== undefined)? Math.abs(drawdownRule.currentValue) : 0;
    },
    formatDate(date) {
      return `${date.getDate()} ${this.months[date.getMonth()]} / ${date.getFullYear()}`;
    },
    restartTest() {
      this.$router.push({
        name: 'funding-simulation-on-boarding',
        params: { market: this.market, firstCreated: true },
      });
    },
    goToVendor() {
      window.open(this.$store.state.fundingTest.evaluation.vendorMainWebsite);
    },
    backToTest() {
      this.$router.push({ name: 'funding-simulation-home' });
    }
  }
}
</script>

<i18n>
{
  "en": {
    "titles": {
      "WINNER": "You Win!",
      "DISQUALIFIED": "You Lose",
      "ABANDONED": "You abandoned"
    },
    "target": {
      "targetTitle": "Target Profit",
      "reachedProfitTitle": "Reached Profit"
    },
    "drawdown": {
      "maxTitle": "Max Drawdown Limit",
      "currentTitle": "Max Drawdown"
    },
    "summary": {
      "title": "Summary",
      "market": {
        "Forex": "Funding evaluation on Forex",
        "Futures": "Funding evaluation on Futures"
      }
    },
    "months": {
      "jan" : "Jan",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Apr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "dateRange": "From <b>{from}</b> to <b>{to}</b>",
    "totalDays": "You had <b>{days} days</b> of evaluation",
    "brokerAccount": "Participated with <b>{identifier}</b>",
    "btnRestart": "Start another evaluation",
    "btnGoToVendor": "Go to a real evaluation in {vendor}",
    "btnBackToTest": "« Evaluations"
  },
  "es": {
    "titles": {
      "WINNER": "¡Ganaste!",
      "DISQUALIFIED": "Perdiste",
      "ABANDONED": "Abandonaste"
    },
    "target": {
      "targetTitle": "Rendimiento Objetivo",
      "reachedProfitTitle": "Rendimiento Alcanzado"
    },
    "drawdown": {
      "maxTitle": "Límite de Drawdown",
      "currentTitle": "Máximo Drawdown"
    },
    "summary": {
      "title": "Resumen",
      "market": {
        "Forex": "Prueba de fondeo en Forex",
        "Futures": "Prueba de fondeo en Futuros"
      }
    },
    "months": {
      "jan" : "Ene",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Abr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "dateRange": "De <b>{from}</b> al <b>{to}</b>",
    "totalDays": "Hiciste <b>{days} días</b> de prueba",
    "brokerAccount": "Participaste con <b>{identifier}</b>",
    "btnRestart": "Comenzar otra prueba",
    "btnGoToVendor": "Haz una prueba real en {vendor}",
    "btnBackToTest": "« Pruebas"
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";

.white-content {
  color: $white-color;
}

.winner {
  .border {
    border-color: $primary-color;
  }
  .text-icon {
    color: $primary-color;
  }
  .button {
    border-color: $primary-color !important;
    color: $white-color !important;
  }
}

.disqualified {
  .border {
    border-color: $negative-color;
  }
  .text-icon {
    color: $negative-color;
  }
  .button {
    border-color: $negative-color !important;
    color: $white-color !important;
  }
}

.abandoned {
  .border {
    border-color: $secondary-color;
  }
  .text-icon {
    color: $secondary-color;
  }
  .button {
    border-color: $secondary-color !important;
    color: $white-color !important;
  }
}
</style>
